import { UpdateIndustryComponent } from './update-industry/update-industry.component';
import { CreateIndustryComponent } from './create-industry/create-industry.component';
import { IndustriesComponent } from './industries.component';
import { MainLayoutComponent } from '@components/main-layout/main-layout.component';
import { Routes } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { NgxPermissionsGuard } from 'ngx-permissions';

export const industriesRoutes: Routes = [
    {
        path: 'admin/industries',
        component: MainLayoutComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'ADMIN_PANEL',
                redirectTo: '/'
            }
        },
        children: [
            { path: '', component: IndustriesComponent },
            { path: 'create', component: CreateIndustryComponent },
            { path: ':id/update', component: UpdateIndustryComponent }
        ]
    }
];
